module.exports = __webpack_public_path__ + "img/weigth-stations1.15b063fe.png";